export enum CustomerLayoutsField {
	Id = 'Id',
	Name = 'Name',
	Width = 'Width',
	Height = 'Height'
}
